// extracted by mini-css-extract-plugin
export default {"error":"Wrapper__error--hWT"};